import type { NextPage } from 'next';
import { CabinetNavigation, CabinetMainInfo, Page, Button, Modal } from '../../components';

import styles from '../../styles/pages/Cabinet.module.scss';
import { useQuery } from '@apollo/client';
import { PROFILE_QUERY } from '../../api/public/cabinet/profile';
import { ContactManager } from '../../components/ContactManager/ContactManager';
import { useState } from 'react';
import NoManager from '../../public/images/newSVG/noManager.svg';
import Whatsapp from '../../public/images/newSVG/whatsapp2.svg';
import { formatPhone } from '../../features/string';
import Image from 'next/image';
import HelpMail from '../../components/CabinetMainInfo/components/HelpMail';

const Cabinet: NextPage = () => {
  const [isContactManagerModalOpen, setIsContactManagerModalOpen] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);

  const { data } = useQuery(PROFILE_QUERY);

  const manager = data?.profile.manager;

  return (
    <Page title='Личный кабинет'>
      <CabinetNavigation 
        breadcrums={[
          { text: 'Личный кабинет', url: '/cabinet' },
          { text: 'Главная', url: '/cabinet' },
        ]}
      >
        <div className={styles.container}>
          <div className={styles.leftContainer}>
            <CabinetMainInfo />
          </div>
          <div className={styles.rightContainer}>
            {!manager 
              ? 
                <>
                  <h3>Контакты</h3>
                  <a href={`mailto:sales@ensys.store`}>sales@ensys.store</a>
                  <Button onClick={() => setIsContactManagerModalOpen(true)} variant='outlined'>Связаться с менеджером</Button>
                </>
              : 
                <>
                  <h3>Ваш менеджер</h3>
                  <div className={styles.manager}>
                    {!manager.image?.id ? <NoManager /> : <Image width={100} height={100} src={`${process.env.NEXT_PUBLIC_S3_CONTAINER}/admin_images/${manager.image.id}_sm.jpeg`} alt={`${manager.personal?.firstname} ${manager.personal?.surname}`} />}
                    <div className={styles.managerInfo}>
                      <p>{manager.personal?.firstname } {manager.personal?.surname}</p>
                      <a href={`mailto:${manager.email}`}>{manager.email}</a>
                      <div className={styles.managerPhoneContainer}>
                        <a href={`tel:+${manager.phone}`} className={styles.managerPhone}>
                          {formatPhone(manager.phone)}
                        </a>
                        <a target='_blank' href={`https://wa.me/${manager.phone}`}>
                          <Whatsapp />
                        </a>
                      </div>
                    </div>
                  </div>
                  <Button onClick={() => setShowHelpModal(true)}>Связаться с менеджером</Button>
                </>
              }
              <div className={styles.suggestion}>
                <h3>Чего-то не хватает?</h3>
                <p>
                  Оставьте свой отзыв и помогите нам
                  сделать маркетплейс лучше.
                </p>
                <Button type='link' href='/cabinet/feedback'>Оставить отзыв</Button>
              </div>
            </div>
        </div>
        <ContactManager isModalOpen={isContactManagerModalOpen} setIsModalOpen={() => setIsContactManagerModalOpen(false)} />
        <Modal title='Сообщение менеджеру' onClose={() => setShowHelpModal(false)} show={showHelpModal}>
          <HelpMail />
        </Modal>
      </CabinetNavigation>
    </Page>
  );
};

export default Cabinet;
